module.exports = __webpack_public_path__ + "static/media/cite.27c04ab4.png";